var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000976562,
    y: -0.000488281,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D4ADF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.001 9.99951C14.4781 9.99951 10.001 14.4767 10.001 19.9995C10.001 24.9908 13.6578 29.1278 18.4385 29.878V22.8901H15.8994V19.9995H18.4385V17.7964C18.4385 15.2901 19.9314 13.9058 22.2156 13.9058C23.3097 13.9058 24.4541 14.1011 24.4541 14.1011V16.562H23.1931C21.9509 16.562 21.5635 17.3329 21.5635 18.1237V19.9995H24.3369L23.8936 22.8901H21.5635V29.878C26.3441 29.1278 30.001 24.9908 30.001 19.9995C30.001 14.4767 25.5238 9.99951 20.001 9.99951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bbf0dd89920d6ababa42e3eefd43194f.svg";
export { ForwardRef as ReactComponent };